import { render, staticRenderFns } from "./ClientesEvolucaoTicketMensalCliente.vue?vue&type=template&id=75617a9a&scoped=true&"
import script from "./ClientesEvolucaoTicketMensalCliente.vue?vue&type=script&lang=js&"
export * from "./ClientesEvolucaoTicketMensalCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClientesEvolucaoTicketMensalCliente.vue?vue&type=style&index=0&id=75617a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75617a9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
